/**
 * News Page JavaScript
 * Handles the appearing text animation positioned 10rem above screen center
 * Uses the exact same animation logic as home page step reveal
 */

document.addEventListener("DOMContentLoaded", function () {
  // Step reveal initialization is now handled by the step-reveal.js module

  // ===== NEWS SWIPER INITIALIZATION =====
  function initNewsSwiper() {
    const swiperContainer = document.querySelector(".news-swiper");

    if (!swiperContainer) {
      return;
    }

    if (typeof Swiper === "undefined") {
      return;
    }

    try {
      const swiper = new Swiper(swiperContainer, {
        slidesPerView: 1.1,
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        speed: 800,
        effect: "slide",

        breakpoints: {
          768: {
            slidesPerView: 1.4,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 1.4,
            spaceBetween: 80,
          },
        },
      });

      return swiper;
    } catch (error) {
      return null;
    }
  }

  // Initialize news swiper
  initNewsSwiper();
});
